// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5P4xw","top":"styles_top__2jN2F"};